import React from "react";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid p-4">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="card shadow-sm">
            <div className="card-body p-5">
              <div className="d-flex align-items-center mb-4">
                <button
                  className="btn btn-outline-secondary me-3"
                  onClick={() => navigate(-1)}
                  style={{ borderRadius: "8px" }}
                >
                  ← Back
                </button>
                <h1 className="h2 mb-0">Terms & Conditions</h1>
              </div>
              
              <div className="text-muted mb-4">
                <small>Last updated: {new Date().toLocaleDateString()}</small>
              </div>

              <div className="terms-content">
                <section className="mb-4">
                  <h3 className="h4 mb-3">Acceptance of Terms</h3>
                  <p className="mb-3">
                    By accessing and using this service, you accept and agree to be bound by the terms 
                    and provision of this agreement. If you do not agree to abide by the above, 
                    please do not use this service.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Use License</h3>
                  <p className="mb-3">
                    Permission is granted to temporarily download one copy of the materials on our 
                    platform for personal, non-commercial transitory viewing only. This is the grant 
                    of a license, not a transfer of title, and under this license you may not:
                  </p>
                  <ul className="mb-3">
                    <li>Modify or copy the materials</li>
                    <li>Use the materials for any commercial purpose or for any public display</li>
                    <li>Attempt to reverse engineer any software contained on the platform</li>
                    <li>Remove any copyright or other proprietary notations from the materials</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">User Accounts</h3>
                  <p className="mb-3">
                    When you create an account with us, you must provide information that is accurate, 
                    complete, and current at all times. You are responsible for:
                  </p>
                  <ul className="mb-3">
                    <li>Safeguarding the password and all activities under your account</li>
                    <li>Notifying us immediately of any unauthorized use</li>
                    <li>Ensuring your account information remains accurate and up-to-date</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Prohibited Uses</h3>
                  <p className="mb-3">
                    You may not use our service:
                  </p>
                  <ul className="mb-3">
                    <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
                    <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
                    <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
                    <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
                    <li>To submit false or misleading information</li>
                    <li>To upload or transmit viruses or any other type of malicious code</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Service Availability</h3>
                  <p className="mb-3">
                    We strive to provide uninterrupted service, but we cannot guarantee 100% uptime. 
                    We reserve the right to modify, suspend, or discontinue the service at any time 
                    without notice.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Payment Terms</h3>
                  <p className="mb-3">
                    If you purchase services from us:
                  </p>
                  <ul className="mb-3">
                    <li>All fees are non-refundable unless otherwise stated</li>
                    <li>You agree to pay all charges incurred by your account</li>
                    <li>Prices are subject to change with notice</li>
                    <li>We may suspend service for non-payment</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Limitation of Liability</h3>
                  <p className="mb-3">
                    In no event shall our company or its suppliers be liable for any damages 
                    (including, without limitation, damages for loss of data or profit, or due to 
                    business interruption) arising out of the use or inability to use the materials 
                    on our platform.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Governing Law</h3>
                  <p className="mb-3">
                    These terms and conditions are governed by and construed in accordance with the 
                    laws of [Your Jurisdiction] and you irrevocably submit to the exclusive 
                    jurisdiction of the courts in that state or location.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Changes to Terms</h3>
                  <p className="mb-3">
                    We reserve the right to revise these terms at any time without notice. 
                    By using this platform, you are agreeing to be bound by the then current 
                    version of these terms and conditions.
                  </p>
                </section>

                <section className="mb-4">
                  <h3 className="h4 mb-3">Contact Information</h3>
                  <p className="mb-3">
                    If you have any questions about these Terms & Conditions, please contact us at:
                  </p>
                  <div className="bg-light p-3 rounded">
                    <p className="mb-1"><strong>Email:</strong> legal@buddyx.com</p>
                    <p className="mb-0"><strong>Address:</strong> [Your Company Address]</p>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
